/**
 * @generated SignedSource<<36774dee2ae5df74147e1e12543339e7>>
 * @relayHash fae8e09125eb3d1a476092d10f1ca7df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dd41e53ec61eb3d70cb5d16d4e6f89be50283eb1ca953cdce0560bd5f9460de0

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraVersionApproverStatus = "APPROVED" | "DECLINED" | "PENDING" | "%future added value";
export type JiraVersionUpdateApproverStatusInput = {
  approverId: string;
  status?: JiraVersionApproverStatus | null | undefined;
};
export type approvalStatus_softwareReleasesApproversMutation$variables = {
  input: JiraVersionUpdateApproverStatusInput;
};
export type approvalStatus_softwareReleasesApproversMutation$data = {
  readonly jira: {
    readonly updateJiraVersionApproverStatus: {
      readonly approver: {
        readonly id: string;
        readonly status: JiraVersionApproverStatus | null | undefined;
      } | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type approvalStatus_softwareReleasesApproversMutation = {
  response: approvalStatus_softwareReleasesApproversMutation$data;
  variables: approvalStatus_softwareReleasesApproversMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraVersionUpdateApproverStatusPayload",
        "kind": "LinkedField",
        "name": "updateJiraVersionApproverStatus",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "JiraVersionApprover",
            "kind": "LinkedField",
            "name": "approver",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "approvalStatus_softwareReleasesApproversMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "approvalStatus_softwareReleasesApproversMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "dd41e53ec61eb3d70cb5d16d4e6f89be50283eb1ca953cdce0560bd5f9460de0",
    "metadata": {},
    "name": "approvalStatus_softwareReleasesApproversMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7843a481920e13d3191728ecd38dfb98";

export default node;
